import { Filter } from "./filter";

export class ByPriority extends Filter {
  constructor(public id?: number) {
    super("by.priority");
  }
}
